import './App.css';
import { ReactTagManager } from 'react-gtm-ts';

const tagManagerArgs = {
  code: 'GTM-WZQPMC7'
}

function App() {
  ReactTagManager.init(tagManagerArgs)
  const token = new URLSearchParams(window.location.search).get('token');
  if (token) {
    window.location.href = `https://www.wix.com/installer/install?token=${token}&appId=ea545d7f-d7de-4626-bc73-f5b78f3620b8&redirectUrl=https://certifiedcode.wixsite.com/fup-app/_functions/@certifiedcode/base-backend/auth`;
  }

  return <></>
}

export default App;
